import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DateRangeValue, getDaysAgoIL, getTodayIL } from '../components/dashboard/DateRangeSelector';

interface DateRangeState {
  dateRange: DateRangeValue;
  setDateRange: (dateRange: DateRangeValue) => void;
}

export const useDateRangeStore = create<DateRangeState>()(
  persist(
    (set) => ({
      dateRange: {
        startDate: getDaysAgoIL(30),
        endDate: getTodayIL(),
      },
      setDateRange: (dateRange) => set({ dateRange }),
    }),
    {
      name: 'date-range-storage',
    }
  )
);
